import type { BackofficeTag } from '../types';

const STATUS_CLASS_NAMES: Record<BackofficeTag['status'], string> = {
  active: 'bg-emerald-100 text-emerald-800',
  archived: 'bg-neutral-200 text-neutral-700',
};

function formatStatus(status: BackofficeTag['status']) {
  return status.replace(/^./, (first) => first.toUpperCase());
}

export function TagStatusChip({ status }: { status: BackofficeTag['status'] }) {
  return (
    <span
      className={`inline-flex rounded-full px-2.5 py-1 text-small font-medium ${STATUS_CLASS_NAMES[status]}`}
    >
      {formatStatus(status)}
    </span>
  );
}
